import React from 'react';
import { Button } from 'reactstrap';
import ReactMarkdown from 'react-markdown';

const SuggestedQuestions = ({ questions, onQuestionClick, t }) => {
  // if (!Array.isArray(questions) || questions.length === 0) {
  //   return null;
  // }
  const isArabic = (text) => /[\u0600-\u06FF]/.test(text);

  return (
    <div className="suggested-questions-container mt-3">
      <h6 className="text-muted fs-12 mb-2">{t("Suggestions")}</h6>
      <div className="d-flex flex-wrap gap-2 markdown-content">
        {/* {questions.map((question, index) => ( */}
          <Button
            // key={index}
            color="light"
            size="sm"
            className="rounded-pill"
            onClick={() => onQuestionClick(questions)}
            style={{
              textAlign: 'left',
              fontWeight: 500,
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}
          >
            <i className="ri-question-line"></i>
            <div dir="auto" className="markdown-content">
              <ReactMarkdown components={{ p: 'span' }}>{questions}</ReactMarkdown>
            </div>
            {isArabic(questions) ? (
              <i className="ri-arrow-left-up-line"></i>
            ) : (
              <i className="ri-arrow-right-up-line"></i>
            )}          
            </Button>
        {/* ))} */}
      </div>
    </div>
  );
};

export default SuggestedQuestions;